export default "__VITE_ASSET__CfBzJJaY__"